function FormatAmount(amount){
    return Number(amount).toFixed(2);
}

export default FormatAmount;